import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import styledTheme from '../../../styles/theme'

import Panel from '../../display/Panel'
import AdventureCard from '../../../pages/listing/Adventures/AdventureCard'

export const Marker = styled.button`
  width: 40px;
  height: 40px;
  margin-left: -20px;
  margin-top: -20px;
  padding: 0;

  appearance: none;
  outline: none;
  border: none;
  border-radius: 50%;

  font-size: 14px;
  font-weight: 500;
  text-align: center;

  color: ${({ theme }) => theme.brand.forest};
  background-color: ${({ theme }) => theme.brand.sunup};

  .icon,
  svg {
    display: inline-block;
    vertical-align: middle;
    font-size: 24px;
    line-height: 1;
  }

  ${({ big }) =>
    big &&
    `
    width: 80px;
    height: 80px;
    margin-left: -40px;
    margin-top: -40px;

    .icon,
    svg {
      font-size: 40px;
    }
  `}

  ${({ jungle, theme }) =>
    jungle &&
    `
    color: white;
    background-color: ${theme.brand.jungle};
  `}

  ${({ standalone }) =>
    standalone &&
    `
    margin: 0;
  `}
`

const AdventureCardPopup = styled.div`
  position: absolute;
  width: 230px;
  left: 50%;
  top: 40px;

  text-align: left;
  border-radius: 5px;

  transform: translate(-50%, 0);

  box-shadow: 0 6px 2px 0 rgba(0, 0, 0, 0.1);

  z-index: 9;

  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -8px;
    transform: rotate(45deg);
    width: 16px;
    height: 16px;
  }

  &:before {
    top: -8px;
    background-color: #d1d1d1;
  }

  &:after {
    top: -7px;
    background-color: ${({ theme }) => theme.brand.sand};
  }
`

export class AdventureMarker extends React.Component {
  state = {
    open: false,
  }

  handleOpen = () => {
    const { onClick } = this.props
    const { open } = this.state
    this.setState({ open: true })
    if (!open) {
      onClick()
    }
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { open } = this.state
    const { listing, adventure, children, ...props } = this.props
    return (
      <Marker {...props} onClick={this.handleOpen}>
        <div>
          {children}
          <Panel
            id={`adventure-${adventure.id}`}
            open={open}
            onClose={this.handleClose}
          >
            <ThemeProvider theme={styledTheme}>
              <AdventureCardPopup>
                <AdventureCard {...adventure} hideIcon />
              </AdventureCardPopup>
            </ThemeProvider>
          </Panel>
        </div>
      </Marker>
    )
  }
}
